<template>
  <div id="main">
    <div id="icrtouch-logo">
      <a href="https://www.icrtouch.com" alt="ICRTouch">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 759.33 134.75">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <g id="ICRTOUCH">
                <polygon
                  id="H"
                  points="689.11 28.79 710.5 28.79 710.5 57.67 737.95 57.67 737.95 28.79 759.33 28.79 759.33 105.95 737.95 105.95 737.95 76.63 710.5 76.63 710.5 105.95 689.11 105.95 689.11 28.79"
                ></polygon>
                <path
                  id="C"
                  d="M605.93,67.59v-.22c0-22.49,17.3-40.12,40.68-40.12,15.76,0,25.9,6.6,32.73,16.09L663.25,55.8c-4.41-5.51-9.49-9-16.88-9-10.8,0-18.4,9.15-18.4,20.39v.23C628,79,635.58,88,646.38,88c8.05,0,12.79-3.75,17.42-9.37l16.09,11.46c-7.27,10-17.09,17.41-34.17,17.41-22,0-39.79-16.87-39.79-39.91"
                ></path>
                <path
                  id="U"
                  d="M526.95,72.12V28.79h21.71V71.67c0,11.13,5.63,16.42,14.22,16.42S577.1,83,577.1,72.23V28.79h21.71V71.56c0,24.9-14.22,35.83-36.15,35.83s-35.71-11.13-35.71-35.27"
                ></path>
                <path
                  id="O"
                  d="M436.61,67.59v-.22c0-22.16,17.86-40.12,41.66-40.12S519.71,45,519.71,67.15v.23c0,22.16-17.85,40.12-41.66,40.12s-41.44-17.75-41.44-39.91m61.28,0v-.22c0-11.14-8.05-20.83-19.84-20.83S458.53,56,458.53,67.15v.23c0,11.13,8.05,20.83,19.74,20.83S497.89,78.73,497.89,67.59Z"
                ></path>
                <polygon
                  id="T"
                  points="387.13 47.53 363.98 47.53 363.98 28.79 431.65 28.79 431.65 47.53 408.52 47.53 408.52 105.95 387.13 105.95 387.13 47.53"
                ></polygon>
                <path
                  id="R"
                  d="M287.31,28.79h36.49c11.79,0,20,3.09,25.13,8.38,4.51,4.41,6.84,10.36,6.84,18v.22c0,11.79-6.27,19.61-15.87,23.69L358.3,106H333.61L318.07,82.58h-9.37V106H287.31V28.79Zm35.5,37c7.27,0,11.46-3.53,11.46-9.14v-.23c0-6.07-4.4-9.15-11.57-9.15h-14V65.83Z"
                ></path>
                <path
                  id="C-2"
                  data-name="C"
                  d="M207.11,67.59v-.22c0-22.49,17.31-40.12,40.67-40.12,15.76,0,25.91,6.6,32.74,16.09L264.43,55.8c-4.41-5.51-9.48-9-16.86-9-10.81,0-18.41,9.15-18.41,20.39v.23C229.15,79,236.76,88,247.56,88c8,0,12.78-3.75,17.42-9.37l16.09,11.46c-7.27,10-17.09,17.41-34.17,17.41-22,0-39.79-16.87-39.79-39.91"
                ></path>
                <rect id="I" x="178.51" y="28.79" width="21.49" height="77.16"></rect>
              </g>
              <path
                d="M36.36,7.56A67.64,67.64,0,0,0,7.09,37.3a1.57,1.57,0,0,0,1.42,2.25h26a4.13,4.13,0,0,0,4.11-4.11V9A1.57,1.57,0,0,0,36.36,7.56Z"
              ></path>
              <path
                d="M89.22,4.78a1.58,1.58,0,0,0-1.08-1.5,67.34,67.34,0,0,0-41.53,0,1.58,1.58,0,0,0-1.08,1.5V35.44a4.13,4.13,0,0,0,4.11,4.11H85.11a4.13,4.13,0,0,0,4.11-4.11Z"
              ></path>
              <path
                d="M96.12,35.44a4.13,4.13,0,0,0,4.11,4.11h26a1.57,1.57,0,0,0,1.42-2.25A67.64,67.64,0,0,0,98.39,7.56,1.57,1.57,0,0,0,96.12,9Z"
              ></path>
              <path
                d="M38.63,85.11V49.65a4.13,4.13,0,0,0-4.11-4.11H4.78a1.58,1.58,0,0,0-1.5,1.08,67.35,67.35,0,0,0,0,41.53,1.58,1.58,0,0,0,1.5,1.08H34.52A4.13,4.13,0,0,0,38.63,85.11Z"
              ></path>
              <rect x="45.53" y="45.53" width="43.69" height="43.69" rx="4.11" ry="4.11"></rect>
              <path
                d="M96.12,49.65V85.11a4.13,4.13,0,0,0,4.11,4.11H130a1.58,1.58,0,0,0,1.5-1.08,67.35,67.35,0,0,0,0-41.53,1.58,1.58,0,0,0-1.5-1.08H100.24A4.13,4.13,0,0,0,96.12,49.65Z"
              ></path>
              <path
                d="M38.63,99.32a4.13,4.13,0,0,0-4.11-4.11h-26a1.57,1.57,0,0,0-1.42,2.25A67.64,67.64,0,0,0,36.36,127.2a1.57,1.57,0,0,0,2.27-1.41Z"
              ></path>
              <path
                d="M89.22,130V99.32a4.13,4.13,0,0,0-4.11-4.11H49.65a4.13,4.13,0,0,0-4.11,4.11V130a1.58,1.58,0,0,0,1.08,1.5,67.34,67.34,0,0,0,41.53,0A1.58,1.58,0,0,0,89.22,130Z"
              ></path>
              <path
                d="M126.25,95.2h-26a4.13,4.13,0,0,0-4.11,4.11v26.47a1.57,1.57,0,0,0,2.27,1.41,67.64,67.64,0,0,0,29.27-29.74A1.57,1.57,0,0,0,126.25,95.2Z"
              ></path>
            </g>
          </g>
        </svg>
      </a>
    </div>
    <div id="tta-logo">
      <router-link to="/">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 841.89 125.18">
          <polyline
            class="a"
            points="174.47 33.55 225.07 33.55 225.07 41.67 204.08 41.67 204.08 99.59 195.66 99.59 195.46 41.67 174.47 41.67"
          ></polyline>
          <path
            class="a"
            d="M220.59,76c0-15.25,8.81-24.65,23.16-24.65,14.95,0,23.47,8.91,23.47,24.55,0,15.45-8.62,24.46-23.28,24.46-14.85,0-23.35-8.82-23.35-24.36m8.12.1c0,11.58,5.05,17.42,15.14,17.42,10.3,0,15.24-5.64,15.24-17.42S254.15,58.5,244.25,58.5C233.76,58.5,228.71,64.24,228.71,76.12Z"
          ></path>
          <path
            class="a"
            d="M277.42,52.16h7.72V82.66c0,7.63,3.27,11.29,10,11.29,8.23,0,13.08-4.65,13.08-12.37V52.16h7.62V99.59h-7.62V93.25c-3.86,4.85-8.42,7.13-14.46,7.13-10.2,0-16.34-6.53-16.34-17.43"
          ></path>
          <path
            class="a"
            d="M362,90.67V97.6a29.75,29.75,0,0,1-13.07,2.78c-14,0-22.57-9.31-22.57-24.36,0-14.86,9.4-24.65,23.85-24.65A28.21,28.21,0,0,1,362,53.85v7.71a21.57,21.57,0,0,0-11.29-2.87c-10.5,0-16.24,6.14-16.24,17.43,0,5.94,1.89,11.19,5,14,2.48,2.07,5.64,3.06,10.2,3.06A31,31,0,0,0,362,90.67"
          ></path>
          <path
            class="a"
            d="M370.44,33.55h7.62V57.9c4.56-4.55,9.2-6.53,15.44-6.53,10,0,15.74,6.14,15.74,16.83V99.59h-7.62V69.39c0-8-2.87-11.09-10.4-11.09-8.71,0-13.16,4.06-13.16,12.17V99.59h-7.62"
          ></path>
          <polyline
            class="a"
            points="411.67 33.55 462.26 33.55 462.26 41.67 441.27 41.67 441.27 99.59 432.87 99.59 432.67 41.67 411.67 41.67"
          ></polyline>
          <path
            class="a"
            d="M589.59,97a39,39,0,0,1-15.2,2.8,23.61,23.61,0,0,1-16.7-6.34c-4.87-4.68-7.11-10.25-7.11-18.24,0-14.93,8.68-24.48,21.84-24.48,12,0,20,8.49,20,21.07v6.44H558.78c.1,3.61.49,5,2.25,7.8,3.11,4.79,7.22,6.93,14.12,6.93,4.8,0,9-1,14.45-3.32M558.68,71.79h26.24c-.49-9.17-5.27-14.53-13.07-14.53S559,62.82,558.68,71.79Z"
          ></path>
          <path
            class="a"
            d="M485.6,71.34V66.18c0-5.55-3.45-8.18-10.59-8.18a37,37,0,0,0-14.17,2.53V53.32a39.14,39.14,0,0,1,14.47-2.63c11.68,0,18,5.26,18,14.91V84.88c0,6.81.4,8.18,3.06,11.4l-6.82,3.79c-1.68-2.53-2.68-3.19-5.07-3.19a8.2,8.2,0,0,0-3.15.56l-4.46,1.27a20.92,20.92,0,0,1-6.54,1c-8.93,0-14.77-5.65-14.77-14.32a13.89,13.89,0,0,1,4.76-10.71c2.77-2.53,5.75-3.31,11.3-3.31m14,6.43H474.11c-7.33,0-10.38,2.24-10.38,7.22,0,5.15,2.76,7.68,8.89,7.68,8.54,0,13-3.31,13-9.55Z"
          ></path>
          <polyline
            class="a"
            points="506.39 33.44 514.02 33.44 514.02 74.25 538.47 52.06 549.58 52.06 524.12 74.55 549.67 99.51 538.88 99.51 514.02 75.44 514.02 99.51 506.39 99.51"
          ></polyline>
          <path
            class="a"
            d="M630.77,71.42V66.26c0-5.55-3.45-8.18-10.59-8.18A37,37,0,0,0,606,60.61V53.4a39.14,39.14,0,0,1,14.47-2.63c11.68,0,18,5.26,18,14.91V85c0,6.81.4,8.18,3.06,11.4l-6.82,3.79c-1.69-2.53-2.68-3.19-5.07-3.19a8.19,8.19,0,0,0-3.15.56l-4.46,1.27a20.93,20.93,0,0,1-6.54,1c-8.93,0-14.77-5.65-14.77-14.32a13.89,13.89,0,0,1,4.76-10.71c2.77-2.53,5.75-3.31,11.3-3.31m14,6.43H619.28c-7.33,0-10.38,2.24-10.38,7.23,0,5.15,2.76,7.68,8.89,7.68,8.54,0,13-3.31,13-9.55Z"
          ></path>
          <path
            class="a"
            d="M743.61,71.32V66.16c0-5.56-3.45-8.19-10.59-8.19a37.05,37.05,0,0,0-14.17,2.54V53.3a39.14,39.14,0,0,1,14.47-2.64c11.68,0,18,5.26,18,14.91V84.87c0,6.81.4,8.18,3.06,11.4l-6.82,3.79c-1.68-2.53-2.68-3.19-5.07-3.19a8.23,8.23,0,0,0-3.15.56l-4.46,1.27a20.94,20.94,0,0,1-6.54,1c-8.93,0-14.77-5.65-14.77-14.32a13.89,13.89,0,0,1,4.76-10.71c2.77-2.53,5.75-3.31,11.3-3.31m14,6.43H732.13c-7.33,0-10.38,2.24-10.38,7.22,0,5.15,2.76,7.68,8.89,7.68,8.54,0,13-3.31,13-9.55Z"
          ></path>
          <polyline
            class="a"
            points="759.85 50.97 768.72 50.97 784.39 83.55 798.9 50.97 807.47 50.97 780.73 109.55 772.38 109.55 779.89 92.85"
          ></polyline>
          <path
            class="b"
            d="M704.44,52,691.8,89.81,679.31,52h-4.18L662.8,90,650.17,52h-5l15.62,47.15h3.32L677,60.41l12.78,38.7h3.54l16-47.15Z"
          ></path>
          <path
            class="a"
            d="M703.63,50.84,691.81,86.25,680.12,50.84h-5.8L662.78,86.38,651,50.84h-7.34L660,100.24h4.93L677,64l12,36.25h5.15l16.8-49.4Z"
          ></path>
          <path
            class="a"
            d="M108.39,25.06c-5.27,1.28-3.48,10.75,1.82,9.46s3.48-10.75-1.82-9.46m7.7,3.94c-.4,2.43-.58,4.58-2.25,6.43a7.27,7.27,0,0,1-2.35,1.7c-.42.2-1,.36-1,1-.08,1.22.84,2.92,1.11,4.12a41.18,41.18,0,0,1,1,8.62c0,8.93-1.72,18.27-5.65,26.09-1.12,2.24-2.66,5.87-4.72,7.14a4.25,4.25,0,0,1-2.24.26h-4.6c-2.9,0-5.78.26-8.12-2.08-2.76-2.76-2.93-7.76-1.6-11.39.52-1.41,1.19-2.76,1.79-4.13.17-.4.64-1.2.28-1.61-.49-.56-2.27-.21-2.93-.21H66.91c-3.39,0-6.7,0-9.83,1.69A16.82,16.82,0,0,0,50.4,74.4a31,31,0,0,0-2,6.92c-.73,4,.19,8.61,4.1,10,2.5.92,5.62.39,8.23.39H77.07c1.23,0,2.55-.16,3.63.62,1.38,1,1.8,2.68,3.53,3.08,2.37.55,5.07.18,7.48.18h19.78a5.15,5.15,0,0,0,2.78-.35c1.46-.89,1.76-2.53,2.31-4.14a29.06,29.06,0,0,1,1.65-3.76,25.91,25.91,0,0,1,9.08-10,17.79,17.79,0,0,1,9.73-2.6c2,0,4.57.66,5.83-1.7a4.08,4.08,0,0,0-1.34-5.28C139,66,135.85,65.36,133,65c-.83-.11-3,.46-3.48-.54a7.15,7.15,0,0,1-.15-2.65c0-1.17-.42-2.48-.18-3.64.2-1,.78-1.91,1-2.91a24.5,24.5,0,0,0,.38-9.1c-.23-1.51-.53-3.94-1.75-4.82-1-.74-2.59.28-3.61-.4-.62-.41-1-1.85-1.32-2.55a31.11,31.11,0,0,0-5-7.39c-.75-.79-1.71-1.89-2.78-2m-74.4,2.48a4.46,4.46,0,0,0-4,3c-.66,2-.38,4.37-.38,6.43V53c0,2.19-.27,4.73,1,6.55,1.48,2.12,4,1.82,6.14,1.82H55a32.16,32.16,0,0,0,6-.16,4.49,4.49,0,0,0,3.39-3.84,43.74,43.74,0,0,0,.14-6.31V40.17c0-2.29.32-5-1-6.92s-3.86-1.82-5.93-1.82H47.14a37.47,37.47,0,0,0-5.45.05m-.1,4.25c1.32-.44,3.21-.05,4.59-.05H59.32c.41,0,1-.11,1.31.29.59.79.19,3.32.19,4.32V52.43c0,1.13,0,2.27,0,3.4,0,.47,0,1-.44,1.25-1.11.54-3.16.09-4.37.09H42.43c-.42,0-1,.09-1.26-.39-.52-1-.13-3.34-.13-4.46V40.54c0-1.17,0-2.35,0-3.52,0-.53,0-1.11.54-1.28m76.53.19a25.85,25.85,0,0,1,2.77,4.49c.25.47.83,1.36.74,1.94-.12.85-1.48,1.81-1.92,2.55a9.71,9.71,0,0,0-1.13,6.55,8.77,8.77,0,0,0,4.14,6c.63.36,2.39.5,2.78,1.08.25.37.1,1.18.16,1.63.24,1.87-.1,4.09.69,5.83,1.67,3.64,5.38,2.66,8.35,3.21,1.4.25,2.61,1,4,1.4v.12a30.75,30.75,0,0,0-4.17,0,25,25,0,0,0-16.83,10.53A30.68,30.68,0,0,0,114,87.87c-.33.87-.75,3.15-1.46,3.64-.5.35-1.54.12-2.11.12h-5.24c-6.51,0-13.06.23-19.56,0-1,0-1.47-1.43-2.24-2.07a8.19,8.19,0,0,0-4.28-1.79,60.25,60.25,0,0,0-6.52,0H59.64c-2.34,0-5.81.84-7.45-1.46-.92-1.29-.66-3-.34-4.49.68-3.23,1.74-6.7,3.83-9.1,3.36-3.86,7.53-3.76,12-3.76H82.41c-.42,2.75-1.23,5-1.06,7.89.29,4.73,3.07,9.4,7.15,10.83,2.61.92,5.32.7,8,.7s5.69.56,7.91-1.22c3.42-2.75,5.71-8.12,7.31-12.37,4.12-11,5.74-23.37,2.84-35l2.22-2.06,1.3-1.82m7.59,9.38c1.09-.15,1,.7,1.13,1.66a25.64,25.64,0,0,1,0,5.1c-.05.65,0,1.93-.74,2-2.27.35-4.27-2.4-4-4.83a4.33,4.33,0,0,1,3.62-4m-50.13,2c-3.52.62-5,3.54-6.44,6.86-1,2.2-1.3,4.66.88,6.13,1.38.93,3.79.42,5.34.42h9.09a22.72,22.72,0,0,0,4.6-.08c4-.86,2.78-6.83.64-9.13s-4.52-1.6-7.16-2.37c-2.24-.65-4.57-2.26-6.95-1.84m47,40.85c-1.47.47-2.33,3.75-2.84,5.22a19.22,19.22,0,0,1-1.12,2.91c-.29.53-.83,1.16-.79,1.82.07,1.1,1.14,2.39,1.77,3.15a16.12,16.12,0,0,0,6.62,5.16,14,14,0,0,0,13.9-2.3c5.84-4.76,8-14.06,4.89-21.43-.49-1.15-1.19-3.11-2.23-3.74-.64-.39-1.74.1-2.45.1a36.05,36.05,0,0,0-6,.07c-.52.09-1.69.12-2,.63s.85.7,1.08.77a8.49,8.49,0,0,1,4.32,3c3.87,5.33,2.13,14.05-4.1,15.93-4.27,1.29-8.82-1.08-10.48-5.86a15.34,15.34,0,0,1-.53-5.46M52.22,95.88c-.55.5.59,2.42.84,2.91a16.12,16.12,0,0,0,5.83,6.4c6.57,3.85,13.94,2.1,18.91-4a14,14,0,0,0,1.09-1.58,7.14,7.14,0,0,0,.59-1.09,2,2,0,0,0-.81-2.44c-1.22-.54-3.61-.23-4.92-.1-1,.1-1.84,1.48-2.67,2.11a7.68,7.68,0,0,1-6,1.63,8.92,8.92,0,0,1-4-1.81c-.67-.54-1.27-1.46-2-1.8C58,95.64,56.24,96,55,96,54.43,96,52.7,95.46,52.22,95.88Z"
          ></path>
        </svg>
      </router-link>
    </div>
    <div id="mobile-button" :class="{cross:seen}" v-on:click="toggleNav">
      <svg
        id="ham"
        :class="{cross:seen}"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"></path>
      </svg>
      <svg
        id="cross"
        :class="{cross:seen}"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
        ></path>
      </svg>
    </div>
    <div id="nav" :class="{show:seen}">
      <router-link to="/">
        <span v-on:click="home">Home</span>
      </router-link>
      <router-link to="/examples">
        <span v-on:click="example">Examples</span>
      </router-link>
      <router-link to="/commander-app">
        <span v-on:click="commandApp">Commander App</span>
      </router-link>
      <router-link to="/how-to-order">
        <span v-on:click="howToOrder">How To Order</span>
      </router-link>
    </div>
    <div id="overlay" v-on:click="toggleNav" :class="{show:seen}"></div>
    <transition name="page-trans">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seen: false
    };
  },
  methods: {
    example: function() {
      this.seen = false;
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "example";
    },
    home: function() {
      this.seen = false;
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "home";
    },
    commandApp: function() {
      this.seen = false;
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "command";
    },
    howToOrder: function() {
      this.seen = false;
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "how";
    },
    toggleNav: function(e) {
      this.seen = !this.seen;
      e.preventDefault();
    }
  }
};
</script>


<style lang="scss">
* {
  margin: 0;
  box-sizing: border-box;
  line-height: 1.5;
  font-family: "poppins", sans-serif;
}

body {
  height: 100%;
}

h1,
h2,
h3 {
  font-family: "space mono", monospace;
}

h1 {
  font-size: 42px;
  @media (max-width: 450px) {
    font-size: 32px;
  }
}

h2 {
  font-size: 32px;
  @media (max-width: 450px) {
    font-size: 22px;
  }
}

h3 {
  font-size: 22px;
  @media (max-width: 450px) {
    font-size: 18px;
  }
}

::selection {
  background-color: #174e77;
  color: #fff;
}

.default-btn,
.vue-button,
.sec-btn {
  padding: 8px 25px;
  border-radius: 8px;
  display: inline-block;
  margin: auto;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(0);
  transition: 0.2s ease;
}

@media (min-width: 769px) {
  .default-btn,
  .sec-btn {
    margin: 0 10px 0 0;
  }
}

.default-btn:active,
.vue-button:active,
.sec-btn:active {
  transform: translateY(1px);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0);
}

.default-btn,
.vue-button {
  border: 1px solid #174e77 !important;
  background-color: #174e77 !important;
  color: #fff !important;
}

.sec-btn {
  border: 1px solid #174e77;
  background-color: transparent;
  color: #174e77;
}

#tta-logo {
  position: fixed;
  top: 20px;
  left: 20px;
  width: 168px;
  height: 30px;
  z-index: 12;
  a {
    svg {
      fill: #dfdfdf;
      max-width: 250px;
    }
  }
}

#icrtouch-logo {
  position: fixed;
  bottom: 25px;
  left: 25px;
  width: 168px;
  height: 30px;
  z-index: 10;
  a {
    svg * {
      fill: #dfdfdf;
    }
  }
  @media (max-width: 1024px) {
    position: absolute;
  }
}

#mobile-button {
  display: none;
  position: fixed;
  top: 20px;
  right: 20px;
  height: 24px;
  width: 24px;
  z-index: 16;
  transition: 0.2s ease;
  &.cross {
    svg {
      fill: #174e77;
      stroke: #174e77;
    }
  }
  cursor: pointer;
  svg {
    fill: #dfdfdf;
    stroke: #dfdfdf;
  }
  #ham {
    display: block;
    &.cross {
      display: none;
    }
  }
  #cross {
    display: none;
    &.cross {
      display: block;
    }
  }
  @media (max-width: 1024px) {
    display: block;
  }
}

#overlay {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 10;
  &.show {
    display: block;
  }
}

#main {
  position: relative;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  z-index: 9;
  .page {
    position: absolute;
    top: 0;
    left: 0;
    min-height: 100vh;
    min-width: 100vw;
    height: 100%;
    width: 100%;
    padding: 0;
    z-index: 5;
    overflow-x: hidden;
  }
}
#nav {
  position: relative;
  padding: 30px;
  z-index: 9;
  text-align: right;
  color: #1c212e;
  user-select: none;
  transition: transform 0.2s ease;
  z-index: 11;
  @media (max-width: 1024px) {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    transform: translateY(-100%);
    width: 100vw;
    height: auto;
    background-color: #fff;
    text-align: left;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0);
  }
  &.show {
    transform: translateY(0);
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 15;
  }
  &.example {
    color: rgb(223, 223, 223);
    a {
      &:after {
        background-color: rgb(223, 223, 223);
      }
      span {
        transition-delay: 0.3s;
      }
    }
  }
  &.home {
  }
  &.how {
    color: rgb(223, 223, 223);
    a {
      &:after {
        background-color: rgb(223, 223, 223);
      }
      span {
        transition-delay: 0.3s;
      }
    }
  }
  a {
    display: inline-block;
    width: fit-content;
    position: relative;
    font-weight: 300;
    color: inherit;
    margin: 0 15px 0 0;
    text-decoration: none;
    @media (max-width: 1024px) {
      margin: 0 0 10px 0;
      font-size: 22px;
    }
    span {
      color: inherit;
      transition: 0.2s ease;
    }
    &:after {
      content: "";
      position: absolute;
      bottom: -5px;
      left: 0;
      height: 2px;
      width: 100%;
      background-color: #174e77;
      transform: translateY(5px);
      opacity: 0;
      transition: 0.1s ease;
      @media (max-width: 1024px) {
        bottom: 0px;
      }
    }
    &:hover:after {
      transform: translateY(0px);
      opacity: 0.5;
      transition: 0.5s ease;
    }
    &.router-link-exact-active:after {
      transform: translateY(0px);
      opacity: 1;
    }
  }
}

.fadeInB {
  animation: fadeInB 0.25s ease-out both 1;
}

@keyframes fadeInB {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
}

@keyframes fadeOutB {
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  to {
    transform: translateY(20px);
    opacity: 0;
  }
}

@keyframes fadeInT {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
}

@keyframes fadeOutT {
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
}
</style>
